const url: string = document.location.href;
const urlParams: URLSearchParams = new URLSearchParams(window.location.search);
const catalogue: string = urlParams.get('catalogue');

export class CatalogueContext {
    public static isDomestic(): boolean {
        return url.includes('gardens-and-driveways.html') || catalogue === 'domestic';
    }

    public static isCommercial(): boolean {
        return url.includes('commercial.html') || catalogue === 'commercial';
    }

    public static isPOS(): boolean {
        return url.includes('pos.html');
    }

    public static isMarshallsCatalogue(): boolean {
        return this.isCommercial() || this.isDomestic();
    }

    public static getCatalogueQSValue(): string {
        return catalogue;
    }
}